/* eslint-disable class-methods-use-this */
import ReduceStore from "flux/lib/FluxReduceStore";

import { AllPayloads } from "../payloads";

import BarrelActionTypes from "./BarrelActionTypes";

interface State {
    selectedComponentSectionIds: string[];
}

class ComponentSectionSelectionStore extends ReduceStore<State, AllPayloads> {
    getInitialState(): State {
        return {
            selectedComponentSectionIds: []
        };
    }

    setSelectedComponentSections(state: State, {
        selectedComponentSectionIds
    }: {
        selectedComponentSectionIds: string[];
    }): State {
        const selectedComponentSectionSet = new Set(selectedComponentSectionIds);

        return {
            ...state,
            selectedComponentSectionIds: Array.from(selectedComponentSectionSet)
        };
    }

    clearComponentSectionSelection(state: State): State {
        if (state.selectedComponentSectionIds.length === 0) {
            return state;
        }

        return {
            ...state,
            selectedComponentSectionIds: []
        };
    }

    reduce(state: State, action: AllPayloads): State {
        switch (action.type) {
            case BarrelActionTypes.SET_SELECTED_COMPONENT_SECTIONS:
                return this.setSelectedComponentSections(state, action);

            case BarrelActionTypes.CLEAR_COMPONENT_SECTION_SELECTION:
                return this.clearComponentSectionSelection(state);

            default:
                return state;
        }
    }
}

export default ComponentSectionSelectionStore;
export { State as ComponentSectionSelectionStoreState };
